<template>
  <div class="">
    <div v-if="srcList && srcList.length > 1" class="tips">点击图片查看更多</div>
    <img :src="srcList[0]" @click="showImg(0)" style="width: 200px; cursor: pointer" />
  </div>
</template>

<script>
export default {
  name: 'ImgList',
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentIndex: 0,
      previewVisible: false
    }
  },
  computed: {
    url() {
      if (this.imageList && this.imageList.length) {
        return this.imageList[0].url
      }
      return null
    },
    srcList() {
      return this.imageList.map((item) => item.url)
    }
  },
  methods: {
    showImg(index) {
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: index,
        imgList: this.srcList
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tips {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}
</style>
